export default __webpack_public_path__ + "assets/8ade1417cc4478e11acf4a8da819d23f.jpg";